import moment from 'moment'
import { DateFilters } from '../../../model'

export const parseDateFilter = (dateFilter: DateFilters, typeDate: string): Date => {
  switch (dateFilter) {
    case DateFilters.ACTIVES:
      return new Date()
    case DateFilters.ACTIVES_AND_FUTURES:
      return new Date()
    case DateFilters.RECORDS_LIM_200:
      return new Date()
    case DateFilters.RECORDS_LIM_500:
      return new Date()
    case DateFilters.YESTERDAY:
      if (typeDate === 'start') {
        return moment().startOf('day').subtract(1, 'days').toDate()
      }
      return moment().endOf('day').subtract(1, 'days').toDate()
    case DateFilters.TODAY:
      if (typeDate === 'end') {
        return moment(new Date()).add(0, 'days').toDate()
      }
      return new Date()
    case DateFilters.TOMORROW:
      if (typeDate === 'end') {
        return moment(new Date()).add(1, 'days').toDate()
      }
      return new Date()
    case DateFilters.TOMORROW_ONLY:
      if (typeDate === 'start') {
        return moment(new Date()).add(1, 'days').toDate()
      }
      if (typeDate === 'end') {
        return moment(new Date()).add(1, 'days').toDate()
      }
      return new Date()
    case DateFilters.WEEK:
      if (typeDate === 'end') {
        return moment(new Date()).add(7, 'days').toDate()
      }
      return new Date()
    case DateFilters.LASTWEEK:
      if (typeDate === 'start') {
        return moment(new Date()).subtract(7, 'days').toDate()
      }
      return new Date()
    case DateFilters.MONTH:
      if (typeDate === 'start') {
        return moment().startOf('month').toDate()
      }

      if (typeDate === 'end') {
        return moment().endOf('month').toDate()
      }
      return new Date()
    case DateFilters.LASTMONTH:
      if (typeDate === 'start') {
        return moment(new Date()).subtract(1, 'months').startOf('month').toDate()
      }
      if (typeDate === 'end') {
        return moment(new Date()).subtract(1, 'months').endOf('month').toDate()
      }
      return new Date()

    case DateFilters.THIRTYDAYS:
      if (typeDate === 'start') {
        return moment(new Date()).toDate()
      }
      if (typeDate === 'end') {
        return moment(new Date()).add(30, 'days').toDate()
      }
      return new Date()
    case DateFilters.THREE_MONTHS:
      if (typeDate === 'end') {
        return moment(new Date()).toDate()
      }
      if (typeDate === 'start') {
        return moment(new Date()).subtract(3, 'months').startOf('month').toDate()
      }
      return new Date()
    case DateFilters.TWELVE_MONTHS:
      if (typeDate === 'end') {
        return moment(new Date()).toDate()
      }
      if (typeDate === 'start') {
        return moment(new Date()).subtract(12, 'month').startOf('month').toDate()
      }
      return new Date()
    case DateFilters.LAST_CLOSED_QUARTER:
      if (typeDate === 'start') {
        return moment(new Date()).subtract(3, 'months').startOf('quarter').toDate()
      }
      if (typeDate === 'end') {
        return moment(new Date()).subtract(3, 'months').endOf('quarter').toDate()
      }
      return new Date()
    case DateFilters.LAST_CLOSED_YEAR:
      if (typeDate === 'start') {
        return moment().startOf('year').subtract(1, 'year').toDate()
      }

      if (typeDate === 'end') {
        return moment().endOf('year').subtract(1, 'year').toDate()
      }
      return new Date()
    case DateFilters.FIRS_SEMESTER:
      if (typeDate === 'start') {
        return moment().subtract(6, 'months').startOf('year').toDate()
      }

      if (typeDate === 'end') {
        return moment().subtract(6, 'months').startOf('year').add(6, 'months').toDate()
      }
      return new Date()
    case DateFilters.SECOND_SEMESTER:
      if (typeDate === 'start') {
        return moment().startOf('year').subtract(1, 'year').add(6, 'months').toDate()
      }

      if (typeDate === 'end') {
        return moment().endOf('year').subtract(1, 'year').toDate()
      }
      return new Date()
    default:
      return moment(new Date()).add(0, 'days').toDate()
  }
}
